export * from './keyStorage';
export * from './storageObserver';
export * from './webStorage';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/ngx-webstorage/dist/helpers/index.js
// module id = ../../../../ngx-webstorage/dist/helpers/index.js
// module chunks = 18